import React, { useRef, useEffect } from "react";
import SecondaryNav2 from "../../../components/AdminComponents/SecondaryNav2";
import {
  MainAccessEdit,
  SettingsMenu,
} from "../../../components/AdminComponents/MenuItems";
import Sidebar from "../../../components/AdminComponents/SideNav";
import { useNavigate } from "react-router-dom";
import { Form, Input, Button, Space, message, Divider } from "antd";
import Axios from "../../../api/Axios";
import { BackwardOutlined, FormOutlined } from "@ant-design/icons";
import { useSelector, useDispatch } from "react-redux";
import { setMainAccessData } from "../../../store/slices/mainAccessData";
// import { selectMainAccessData } from "../../../store/slices/mainAccessData";

const MainAccessOrgEdit = () => {
  const [messageApi, contextHolder] = message.useMessage();
  const dispatch = useDispatch();
  const formRef = useRef();
  // const temo = useSelector(selectMainAccessData);
  // console.log(temo);
  const allowedPattern = /^[a-zA-Z0-9\s&,/\-()]+$/;
  const dataSource = useSelector((state) => state.mainAccess);
  //console.log(dataSource);

  const handleReset = () => {
    formRef.current.resetFields();
  };
  function getCookie(name) {
    const cookies = document.cookie.split("; ");
    for (let i = 0; i < cookies.length; i++) {
      const [cookieName, cookieValue] = cookies[i].split("=");
      if (cookieName === name) {
        return cookieValue;
      }
    }
    return null;
  }
  const csrfToken = getCookie("csrftoken");
  //console.log(csrfToken);
  const onFinish = async (values) => {
    //console.log(values);
    const apiPayload = {
      id: dataSource?.[0].id,
      name: "Organization",
      status: true,
      side_menu: [
        {
          id: dataSource?.[0].side_menu?.[0].id,
          name: "",
          status: true,
          top_menu: [
            {
              id: dataSource?.[0].side_menu?.[0].top_menu?.[0].id,
              name: values.top1,
              status: true,
              sub_menu: [
                {
                  id: dataSource?.[0].side_menu?.[0].top_menu?.[0].sub_menu?.[0]
                    .id,
                  name: values.sub1,
                  status: true,
                },
                {
                  id: dataSource?.[0].side_menu?.[0].top_menu?.[0].sub_menu?.[1]
                    .id,
                  name: values.sub2,
                  status: true,
                },
                {
                  id: dataSource?.[0].side_menu?.[0].top_menu?.[0].sub_menu?.[2]
                    .id,
                  name: values.sub3,
                  status: true,
                },
                {
                  id: dataSource?.[0].side_menu?.[0].top_menu?.[0].sub_menu?.[3]
                    .id,
                  name: values.sub4,
                  status: true,
                },
                {
                  id: dataSource?.[0].side_menu?.[0].top_menu?.[0].sub_menu?.[4]
                    .id,
                  name: values.sub5,
                  status: true,
                },
              ],
            },
            {
              id: dataSource?.[0].side_menu?.[0].top_menu?.[1].id,
              name: values.top2,
              status: true,
              sub_menu: [
                {
                  id: dataSource?.[0].side_menu?.[0].top_menu?.[1].sub_menu?.[0]
                    .id,
                  name: values.sub21,
                  status: true,
                },
              ],
            },
          ],
        },
      ],
    };
    //console.log(apiPayload);
    try {
      await Axios.put(`/globaluseraccess/`, apiPayload, {
        headers: {
          "X-CSRFToken": csrfToken,
        },
      });
      //console.log(res);
      CreateSuccessfull();
    } catch (err) {
      CreateFailed();
    }
  };
  const CreateSuccessfull = () => {
    messageApi.open({
      type: "success",
      content: "Details have been edited.",
      duration: 5,
    });
    fetchData();
  };
  const CreateFailed = () => {
    messageApi.open({
      type: "error",
      content: "Details have not been edited.",
      duration: 5,
    });
  };
  const fetchData = async () => {
    try {
      const response = await Axios.get(`/globaluseraccess/`);
      dispatch(setMainAccessData(response.data));
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  const history = useNavigate();
  useEffect(() => {
    if (formRef.current) {
      const formValues = {
        top1: `${dataSource?.[0].side_menu[0].top_menu?.[0].name}`,
        top2: `${dataSource?.[0].side_menu[0].top_menu?.[1].name}`,
        sub1: `${dataSource?.[0].side_menu[0].top_menu?.[0].sub_menu?.[0].name}`,
        sub2: `${dataSource?.[0].side_menu[0].top_menu?.[0].sub_menu?.[1].name}`,
        sub3: `${dataSource?.[0].side_menu[0].top_menu?.[0].sub_menu?.[2].name}`,
        sub4: `${dataSource?.[0].side_menu[0].top_menu?.[0].sub_menu?.[3].name}`,
        sub5: `${dataSource?.[0].side_menu[0].top_menu?.[0].sub_menu?.[4].name}`,
        sub21: `${dataSource?.[0].side_menu[0].top_menu?.[1].sub_menu?.[0].name}`,
        sub22: `API`,
      };

      formRef.current.setFieldsValue(formValues);
    }
  }, [dataSource]);
  return (
    <Sidebar props={SettingsMenu}>
      {contextHolder}
      <SecondaryNav2 menuItems={MainAccessEdit} />
      <div className="form-container">
        <Form
          name="complex-form"
          onFinish={onFinish}
          layout="vertical"
          ref={formRef}
          labelCol={{
            span: 14,
          }}
          wrapperCol={{
            span: 16,
          }}
          style={{
            Width: "100%",
          }}
        >
          <div className="group1">
            <div className="form-heading">ORGANIZATION EDIT</div>

            <div className="group-1-box">
              <div style={{ display: "inline-block" }}>
                <div
                  className="form-heading"
                  style={{
                    fontSize: "1.5rem",
                    margin: "0rem",
                    padding: "0rem",
                    paddingBottom: "2rem",
                    paddingTop: "1rem",
                    fontWeight: "500",
                    color: "blue",
                    paddingLeft: "0.5rem",
                  }}
                >
                  TOP Menus
                </div>
                <Form.Item>
                  <Space>
                    <Form.Item
                      name="top1"
                      noStyle
                      rules={[
                        {
                          required: true,
                          pattern: /^[a-zA-Z]+$/,
                          message: "Please enter only letters.",
                        },
                      ]}
                    >
                      <Input
                        className="my-form-input"
                        style={{ width: "23rem" }}
                        placeholder="Enter menu name"
                      />
                    </Form.Item>
                  </Space>
                </Form.Item>
              </div>
              <div style={{ display: "inline-block", marginLeft: "2rem" }}>
                <Form.Item>
                  <Space>
                    <Form.Item
                      name="top2"
                      noStyle
                      rules={[
                        {
                          required: true,
                          pattern: /^[a-zA-Z]+$/,
                          message: "Please enter only letters.",
                        },
                      ]}
                    >
                      <Input
                        className="my-form-input"
                        style={{ width: "23rem" }}
                        placeholder="Enter menu name"
                      />
                    </Form.Item>
                  </Space>
                </Form.Item>
              </div>
            </div>
            <Divider
              dashed
              style={{
                color: "gray",
                fontSize: "1rem",
                borderTop: "2px solid #D3D3D3",
                padding: "0rem",
                margin: "0rem",
                marginTop: "2.5rem",
                marginBottom: "1rem",
              }}
            />
            <div className="group-1-box">
              <div style={{ display: "inline-block" }}>
                <div
                  className="form-heading"
                  style={{
                    fontSize: "1.5rem",
                    margin: "0rem",
                    padding: "0rem",
                    paddingBottom: "2rem",
                    fontWeight: "500",
                    color: "blue",
                    paddingLeft: "0.5rem",
                  }}
                >
                  {dataSource?.[0].side_menu[0].top_menu?.[0].name} Sub Menus
                </div>
                <Form.Item>
                  <Space>
                    <Form.Item
                      name="sub1"
                      noStyle
                      rules={[
                        {
                          required: true,
                          pattern: allowedPattern,
                          message: "Please enter only letters.",
                        },
                      ]}
                    >
                      <Input
                        className="my-form-input"
                        placeholder="Enter menu name"
                        style={{ width: "23rem" }}
                      />
                    </Form.Item>
                  </Space>
                </Form.Item>
              </div>

              <div style={{ display: "inline-block", marginLeft: "2rem" }}>
                <Form.Item>
                  <Space>
                    <Form.Item
                      name="sub2"
                      noStyle
                      rules={[
                        {
                          required: true,
                          pattern: allowedPattern,
                          message: "Please enter only letters.",
                        },
                      ]}
                    >
                      <Input
                        className="my-form-input"
                        placeholder="Enter menu name"
                        style={{ width: "23rem" }}
                      />
                    </Form.Item>
                  </Space>
                </Form.Item>
              </div>
              <div style={{ display: "inline-block", marginLeft: "2rem" }}>
                <Form.Item>
                  <Space>
                    <Form.Item
                      name="sub3"
                      noStyle
                      rules={[
                        {
                          required: true,
                          pattern: allowedPattern,
                          message: "Please enter only letters.",
                        },
                      ]}
                    >
                      <Input
                        className="my-form-input"
                        placeholder="Enter menu name"
                        style={{ width: "23rem" }}
                      />
                    </Form.Item>
                  </Space>
                </Form.Item>
              </div>
            </div>

            <div style={{ marginLeft: "3rem", marginTop: "1.5rem" }}>
              <div
                style={{
                  display: "inline-block",
                }}
              >
                <Form.Item>
                  <Space>
                    <Form.Item
                      name="sub4"
                      noStyle
                      rules={[
                        {
                          required: true,
                          pattern: allowedPattern,
                          message: "Please enter only letters.",
                        },
                      ]}
                    >
                      <Input
                        className="my-form-input"
                        placeholder="Enter menu name"
                        style={{ width: "23rem" }}
                      />
                    </Form.Item>
                  </Space>
                </Form.Item>
              </div>
              <div style={{ display: "inline-block", marginLeft: "2rem" }}>
                <Form.Item>
                  <Space>
                    <Form.Item
                      name="sub5"
                      noStyle
                      rules={[
                        {
                          required: true,
                          pattern: allowedPattern,
                          message: "Please enter only letters.",
                        },
                      ]}
                    >
                      <Input
                        className="my-form-input"
                        placeholder="Enter menu name"
                        style={{ width: "23rem" }}
                      />
                    </Form.Item>
                  </Space>
                </Form.Item>
              </div>
            </div>
            <Divider
              dashed
              style={{
                color: "gray",
                fontSize: "1rem",
                borderTop: "2px solid #D3D3D3",
                padding: "0rem",
                margin: "0rem",
                marginBottom: "1rem",
              }}
            />
            <div className="group-1-box">
              <div style={{ display: "inline-block" }}>
                <div
                  className="form-heading"
                  style={{
                    fontSize: "1.5rem",
                    margin: "0rem",
                    padding: "0rem",
                    paddingBottom: "2rem",
                    fontWeight: "500",
                    color: "blue",
                    paddingLeft: "0.5rem",
                  }}
                >
                  {dataSource?.[0].side_menu[0].top_menu?.[1].name} Sub Menus
                </div>
                <Form.Item>
                  <Space>
                    <Form.Item
                      name="sub21"
                      noStyle
                      rules={[
                        {
                          required: true,
                          pattern: /^[a-zA-Z]+$/,
                          message: "Please enter only letters.",
                        },
                      ]}
                    >
                      <Input
                        className="my-form-input"
                        placeholder="Enter menu name"
                        style={{ width: "23rem" }}
                      />
                    </Form.Item>
                  </Space>
                </Form.Item>
              </div>

              <div style={{ display: "inline-block", marginLeft: "2rem" }}>
                <Form.Item>
                  <Space>
                    <Form.Item
                      name="sub22"
                      noStyle
                      rules={[
                        {
                          required: true,
                          pattern: /^[a-zA-Z]+$/,
                          message: "Please enter only letters.",
                        },
                      ]}
                    >
                      <Input
                        className="my-form-input"
                        placeholder="Enter menu name"
                        style={{ width: "23rem" }}
                      />
                    </Form.Item>
                  </Space>
                </Form.Item>
              </div>
            </div>
            <Divider
              dashed
              style={{
                color: "gray",
                fontSize: "1rem",
                borderTop: "2px solid #D3D3D3",
                padding: "0rem",
                margin: "0rem",
                marginBottom: "1rem",
                marginTop: "2rem",
              }}
            />
          </div>
          <div style={{ display: "inline-block", marginLeft: "5rem" }}>
            <Form.Item label=" " colon={false}>
              <Button
                type="text"
                htmlType="button"
                style={{
                  background: "#D3D3D3",
                }}
                onClick={() => {
                  history(`/access-manager/access-rename`);
                }}
              >
                <BackwardOutlined />
                Back
              </Button>
            </Form.Item>
          </div>

          <div style={{ display: "inline-block", marginLeft: "16px" }}>
            <Form.Item label=" " colon={false}>
              <Button type="primary" htmlType="button" onClick={handleReset}>
                Reset
              </Button>
            </Form.Item>
          </div>
          <div style={{ display: "inline-block", marginLeft: "16px" }}>
            <Form.Item label=" " colon={false}>
              <Button
                type="primary"
                htmlType="submit"
                // className="my-form-input-end"
                style={{
                  background: "#f58029",
                  fontWeight: "600",
                }}
                className="save-update-btn"
              >
                Update
                <FormOutlined />
              </Button>
            </Form.Item>
          </div>
        </Form>
      </div>
    </Sidebar>
  );
};

export default MainAccessOrgEdit;
